// Operator platform observability — mirrors OperatorObservabilityService /
// GET /operator/observability. Zod-validated (ContractError on drift).
import { z } from "zod";
import { operatorFetch } from "./client";

export interface OperatorObservability {
  eventQueue: { pending: number; processing: number; done: number; dead: number };
  deadEvents: number;
  relayErasureBacklog: number;
  /** Control-plane→relay reachability. null = not monitored (relay link off). */
  relay: { reachable: boolean | null };
}

const observabilitySchema = z.object({
  eventQueue: z.object({ pending: z.number(), processing: z.number(), done: z.number(), dead: z.number() }),
  deadEvents: z.number(),
  relayErasureBacklog: z.number(),
  relay: z.object({ reachable: z.boolean().nullable() }),
}) satisfies z.ZodType<OperatorObservability>;

export function getOperatorObservability(signal?: AbortSignal): Promise<OperatorObservability> {
  return operatorFetch("/operator/observability", { signal, schema: observabilitySchema });
}
